<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> {{label.filters}}
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <cal-picker v-model="form.tranDateFrom" :label="label.tranDateFrom" v-validate="fromDateValidation(form.tranDateTo)" :data-vv-as="label.tranDateFrom" data-vv-name="tranDateFrom" :error-messages="errors.collect('tranDateFrom')" :min="fromDateMinDate" :max="fromDateMax()"></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker v-model="form.tranDateTo" :label="label.tranDateTo" v-validate="toDateValidation(form.tranDateFrom)" :data-vv-as="label.tranDateTo" data-vv-name="tranDateTo" :error-messages="errors.collect('tranDateTo')" :min="form.tranFromData" :max="today"></cal-picker>
                      </v-flex>
                      <v-flex xs12 md6 lg6>
                        <v-autocomplete :items="accmTypes" v-model="form.accmType" :label="label.accmType" item-text="label" item-value="value" data-vv-name="accmType" :data-vv-as="label.accmType" :error-messages="errors.collect('accmType')" v-validate="'required'"></v-autocomplete>
                      </v-flex>
                      <v-flex md6 lg6></v-flex>
                      <v-flex xs12 sm6 md6 lg6>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12>
          <v-checkbox dense v-model="form.printRptRunTime" :label="label.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="label.printRptRunTime"></v-checkbox>
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{label.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import { checkDateRangeFrom, checkDateRangeTo } from '@/directives/common'

export default {
  data() {
    return {
      label: {
        filters: 'Filters',
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'Transaction Date To',
        accmType: 'Accumulation Type',
        export: 'Export To',
        printRptRunTime: 'Print Runtime Parameters'
      },
      form: {
        tranDateFrom: '',
        tranDateTo: new Date(),
        accmType: '',
        format: 'PDF',
        printRptRunTime: true
      },
      loading: false,
      menu: {},
      supportedFormat: [],
      accmTypes: [],
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      panel: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initSurpTtyTranList
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.getAccmTypeList()
      } catch (err) {
        throw err
      }
    },
    async getAccmTypeList() {
      const apiURI = this.menu.accumTypeList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.accmTypes = []
          if (data) {
            for (let i in data) {
              this.accmTypes.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.genSurpTtyTrans
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.form)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fromDateMax() {
      return new Date(2070, 11, 31)
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  },
  mixins: [
    MessageMixin
  ],
  components: {
  }
}
</script>

<style>

</style>
